/**
 * @generated SignedSource<<0746db3082039ed23c4bd3327f69e2bb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCreditsPolicyDialogQuery$variables = Record<PropertyKey, never>;
export type aiCreditsPolicyDialogQuery$data = {
  readonly seller: {
    readonly aiCreditsPolicyAccepted: boolean;
    readonly id: string;
  } | null;
};
export type aiCreditsPolicyDialogQuery = {
  response: aiCreditsPolicyDialogQuery$data;
  variables: aiCreditsPolicyDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Seller",
    "kind": "LinkedField",
    "name": "seller",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCreditsPolicyAccepted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCreditsPolicyDialogQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiCreditsPolicyDialogQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "d3a2f7304cef322697fcdb71c58a7a8c",
    "id": null,
    "metadata": {},
    "name": "aiCreditsPolicyDialogQuery",
    "operationKind": "query",
    "text": "query aiCreditsPolicyDialogQuery {\n  seller {\n    id\n    aiCreditsPolicyAccepted\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e1b985e72b3ed2ded65717e0dcea5bd";

export default node;
